import * as types from "../actions/actionsTypes";

let initialState = {
  brands:[],
  themes:[]
}

const accountFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACCOUNT_FILTERS:
      return {
        ...state,
        brands: action.data.brands,
        themes: action.data.themes
      }
    case types.RESET_ACCOUNT_FILTERS:      
      return initialState
    default:
      return initialState
  }
}

export default accountFilterReducer;